export default __webpack_public_path__ + "static/media/small_white_right_arrow.cc6f4d24.svg";